<template>
    <div class="flex items-center justify-center gap-3 border-t border-black/10 pt-4">
        <button
            type="button"
            class="flex size-8 cursor-pointer items-center justify-center rounded-md border border-black/10 transition hover:bg-stone-50 disabled:cursor-not-allowed disabled:opacity-40"
            :disabled="currentPage === 1"
            :aria-label="$t('pages.product_detail_page.product_info.product_button.recent_projects_modal.previous_page')"
            @click="emits('previous')"
        >
            <ChevronLeftIcon class="size-4" />
        </button>

        <span class="min-w-16 text-center text-sm text-black/50"> {{ currentPage }} / {{ totalPages }} </span>

        <button
            type="button"
            class="flex size-8 cursor-pointer items-center justify-center rounded-md border border-black/10 transition hover:bg-stone-50 disabled:cursor-not-allowed disabled:opacity-40"
            :disabled="currentPage === totalPages"
            :aria-label="$t('pages.product_detail_page.product_info.product_button.recent_projects_modal.next_page')"
            @click="emits('next')"
        >
            <ChevronRightIcon class="size-4" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { ChevronLeftIcon, ChevronRightIcon } from '@lucide/vue';

defineProps<{
    currentPage: number;
    totalPages: number;
}>();

const emits = defineEmits<{
    previous: [];
    next: [];
}>();
</script>
